import React from "react";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { Warning } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import {
  updateModalManager,
  updateMultiUpload,
} from "../../../reducers/configurator/configuratorSlice";
import { resetLayers } from "../../../reducers/configurator/utils";

const PREFIX = "objectSideManagement";

const classes = {
  marginTop: `${PREFIX}-marginTop`,
  warningIconColor: `${PREFIX}-warningIconColor`,
  textColor: `${PREFIX}-textColor`,
  pairContainer: `${PREFIX}-pairContainer`,
};

const ObjectSideManagementContainer = styled("div")(({ theme }) => {
  return {
    [`& .${classes.marginTop}`]: {
      marginTop: "1rem",
    },
    [`& .${classes.warningIconColor}`]: {
      color: "#f55c5c",
    },
    [`& .${classes.textColor}`]: {
      color: "rgba(255, 255, 255, 0.8)",
    },
    [`& .${classes.pairContainer}`]: {
      display: "flex",
      justifyContent: "space-between",
      widht: "100%",
    },
  };
});

const rotations = [
  ["north", "east"],
  ["south", "west"],
];

const ObjectSideManagement = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedTile = useSelector((state) => state.configurator.selectedTile);
  const parentLayout = useSelector((state) => state.configurator.parentLayout);
  const myTile = useSelector((state) =>
    selectedTile
      ? state.configurator.grid[parentLayout][selectedTile.row][
          selectedTile.column
        ]
      : null
  );

  return (
    <ObjectSideManagementContainer>
      <div className={classes.marginTop}>
        <Typography variant="body1">
          {props.selectedObject && props.selectedObject.onFacade
            ? t("configurator.choseFacade")
            : props.selectedObject && props.selectedObject.isOriented
            ? t("configurator.choseOrientation")
            : ""}
        </Typography>
        <List>
          {rotations.map((pair, index) => {
            return (
              <div
                className={classes.pairContainer}
                key={`rotation-pair-${index + 1}`}
              >
                {pair.map((rotation) => {
                  return (
                    <ListItemButton
                      selected={
                        props.isMultiUpload
                          ? false
                          : rotation === props.element.rotation
                      }
                      onClick={(e) => {
                        if (props.isMultiUpload) {
                          if (props.moveMultiSize) {
                            dispatch(
                              updateModalManager(resetLayers.modalManager)
                            );
                            props.moveMultiSize(rotation);
                          } else
                            dispatch(
                              updateMultiUpload({ orientation: rotation })
                            );
                        } else
                          props.handleChange({ ...props.element, rotation });
                      }}
                      key={rotation}
                      sx={{
                        "&.Mui-selected": {
                          backgroundColor: "rgba(255, 255, 255, 0.16)",
                          "&:hover": {
                            backgroundColor: "rgba(255, 255, 255, 0.16)",
                          },
                        },
                      }}
                    >
                      {!props.isMultiUpload &&
                        myTile[rotation].type &&
                        props.selectedObject.onFacade && (
                          <ListItemIcon className={classes.textColor}>
                            <Warning className={classes.warningIconColor} />
                          </ListItemIcon>
                        )}
                      <ListItemText primary={t(`configurator.${rotation}`)} />
                    </ListItemButton>
                  );
                })}
              </div>
            );
          })}
        </List>
      </div>
    </ObjectSideManagementContainer>
  );
};

export default ObjectSideManagement;
